<template lang='pug'>
  .fpui-input-tag(:class='className', @click='toggle()')
    span.fpui-input-tag-label {{ label }}
    i.fpui.fpui-remove(@click='$emit("remove")', v-if='clearable')
</template>

<script>

export default {
  props: {
    clearable: { type: Boolean, default: false },
    label: { type: String },
    activeColor: { type: String, default: 'blue' },
    notActiveColor: { type: String, default: 'grey' },
    value: { type: Boolean, required: true, default: false },
    disabled: { type: Boolean, default: false }
  },
  methods: {
    toggle () {
      if (this.disabled) return
      this.model = !this.model
    }
  },
  computed: {
    model: {
      get () { return this.value },
      set (val) { this.$emit('input', val) }
    },
    className () {
      let className = []
      if (this.disabled) className.push('disabled')
      if (this.value) className = className.concat([this.activeColor, 'active'])
      if (!this.value) className.push(this.notActiveColor)
      return className.join(' ')
    }
  }
}
</script>

<style lang='less'>
@import "~@/shared/styles/_variables.less";

.fpui-input-tag {
  position: relative;
  border: 10px;
  box-sizing: border-box;
  display: flex;
  font-family: Roboto, sans-serif;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  cursor: pointer;
  text-decoration: none;
  margin: 0px;
  padding: 0px 5px;
  outline: none;
  font-size: inherit;
  font-weight: inherit;
  border-radius: 16px;
  white-space: nowrap;
  width: fit-content;
  color: rgba(0, 0, 0, 0.87);
  .fpui-input-tag-label {
    font-size: 14px;
    font-weight: 400;
    line-height: 32px;
    padding-left: 12px;
    padding-right: 12px;
    user-select: none;
    white-space: nowrap;
  }
  &.grey {
    background-color: rgb(224, 224, 224);
  }
  &.blue {
    background-color: @blue;
    color: @white;
  }
  &.green {
    background-color: @green;
    color: @white;
  }
  &.red {
    background-color: @red;
    color: @white;
  }
  &.yellow {
    background-color: @yellow;
    color: @white;
  }
  .fpui-remove {
    position: absolute;
    right: 5px;
  }
}
</style>